import { OverrideToken } from 'antd/es/theme/interface';

export default <OverrideToken>{
  Tooltip: {
    // colorBgSpotlight: '#3d3d3d',
  },
  Descriptions: {
    // colorText: '#4A4A4A',
    // colorTextTertiary: '#999999',
  },
  Typography: {
    // colorTextSecondary: '#999999',
    // colorText: '#4A4A4A',
    // colorLink: '#ED6C00',
    // colorLinkHover: '#fa8919',
    // colorLinkActive: '#ED6C00',
  },
  Table: {
    // colorBorderSecondary: '#ebebeb',
    // headerColor: '#878C95',
    // headerBg: '#F8F9FB',
    // rowSelectedBg: '#F7F8FA',
  },
  Anchor: {
    // colorPrimary: '#ED6C00',
  },
  Button: {
    // textTextActiveColor: '#ED6C00',
    // textTextColor: '#ED6C00',
    // textHoverBg: 'rgba(250,137,25,0.08)',
    // textTextHoverColor: '#ED6C00',
    // defaultHoverBg: '#FFFAF6',
    // defaultHoverBorderColor: '#FA8919',
    // defaultHoverColor: '#fa8919',
    // defaultColor: '#4a4a4a',
    // contentFontSizeSM: 12,
  },
  Tabs: {
    // itemColor: '#5E5E5E',
    // itemSelectedColor: '#333333',
    // horizontalMargin: '0 0 24px 0',
    // itemHoverColor: '#333333',
    // itemActiveColor: '#333333',
  },
  Select: {
    // colorIcon: '#D2D3D6',
    // colorIconHover: '#B4B5B8',
    // optionActiveBg: '#F8F9FB',
    // optionHeight: 36,
    // optionPadding: '7px 12px',
    // optionSelectedColor: '#333333',
    // optionSelectedBg: 'transparent',
  },
  DatePicker: {
    // cellActiveWithRangeBg: '#FFF6ED',
  },
  TreeSelect: {
    // nodeSelectedColor: '#333333',
    // indentSize: 12,
    // nodeSelectedBg: 'transparent',
  },
  Modal: {
    // titleColor: '#333333',
  },
  Form: {
    // verticalLabelMargin: '0 0 0 4px',
  },
  Tree: {
    titleHeight: 20,
  },
};
